<template>
    <div class="lang">
        <div class="process">
            <div class="info on">
                <ul class="step-box">
                    <li class="step-box__item"><span class="step-box__item--step">STEP 01</span>
                        <div class="step-box__item__top">
                            <h4 class="title03">Reservation</h4>
                        </div>
                    </li>
                    <li class="step-box__item"><span class="step-box__item--step">STEP 02</span>
                        <div class="step-box__item__top">
                            <h4 class="title03">Receipt of materials to be prepared and phone-call for reservation confirmation</h4>
                        </div>
                    </li>
                    <li class="step-box__item"><span class="step-box__item--step">STEP 03</span>
                        <div class="step-box__item__top">
                            <h4 class="title03">Application</h4>
                        </div>
                    </li>
                    <li class="step-box__item"><span class="step-box__item--step">STEP 04</span>
                        <div class="step-box__item__top">
                            <h4 class="title03">Payment</h4>
                        </div>
                    </li>
                    <li class="step-box__item"><span class="step-box__item--step">STEP 05</span>
                        <div class="step-box__item__top">
                            <h4 class="title03">Examination in process</h4>
                        </div>
                    </li>
                    <li class="step-box__item"><span class="step-box__item--step">STEP 06</span>
                        <div class="step-box__item__top">
                            <h4 class="title03">Completion of examination</h4>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="info">
                <h3 class="bullet01">Reservation</h3>
                <p class="bullet03 depth">Telephone reservation: 02-6986-3100</p>
                <p class="bullet03 depth">Contact hours: 09:00 - 17:00 (weekdays, excluding Saturdays and holidays), you will get a phonecall from a nurse once the reservation is finalized.
                    When reserving an examination, please inform us with drugs you are taking in advance.</p>
            </div>
            <div class="info">
                <h3 class="bullet01">Receipt of supply and reservation confirmation call</h3>
                <p class="bullet03 depth">Delivery of checkup detail information after reservation and receipt of supply</p>
                <p class="bullet03 depth">We will give you a confirmation call on your reservation (happy-call) a week before the medical checkup.</p>
                <p class="bullet03 depth">An information msg (SMS) will be sent to your cell phone a day prior to the medical checkup.</p>
            </div>
            <div class="info">
                <h3 class="bullet01">Application</h3>
                <p class="bullet03 depth">Check on reservation and application at the information desk of Wellness Health Promotion Center</p>
                <p class="bullet03 depth">Submission of supplies (questionnaire, fecal sample, etc.)</p>
                <p class="bullet03 depth">Instruction on tests and procedures to be conducted</p>
            </div>
            <div class="info">
                <h3 class="bullet01">Payment</h3>
                <p class="bullet03 depth">Payment of the medical checkup fee</p>
            </div>
            <div class="info">
                <h3 class="bullet01">Examination proceeded</h3>
                <p class="bullet03 depth">Examination proceeded</p>
                <p class="bullet03 depth">Undressing and wearing examination clothing and slippers (getting off all accessories, valuables allowed to be kept separately)</p>
                <p class="bullet03 depth">Medical checkup program proceeded (taking 3 - 6 hours depending on the program)</p>
            </div>
            <div class="info">
                <h3 class="bullet01">Completion of examination</h3>
                <p class="bullet03 depth">Precautions at home to be informed (a meal voucher provided)</p>
                <p class="bullet03 depth">Making a reservation for result review: Choosing one from visit consultation or mail delivery of result</p>
                <p class="bullet03 depth">Postal shipments can only be sent to domestic addresses.</p>
                <p class="bullet03 depth">Email services are also available</p>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>